import { useParams } from "react-router-dom"
import { ToastProvider } from "../../common/components/ui/toast/toast.provider"
import Dashboard from "../../common/components/layout/Dashboard"
import Toast from "../../common/components/ui/toast"
import { CostCenterDashboard } from "./components/cost-center-dashboard"
import { CostCenterDashboardProvider } from "./components/cost-center-dashboard/PurchaseCostCenter.provider"


export default function CostCenterDetailsPage() {
  const { costCenterId } = useParams()

  return (
    <ToastProvider>
      <Dashboard>
        <CostCenterDashboardProvider costCenterId={costCenterId || ''}>
          <CostCenterDashboard />
        </CostCenterDashboardProvider>
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

